export default __webpack_public_path__ + "static/media/newsletter.ead4306b.png";